import { render, staticRenderFns } from "./CreateLesson.vue?vue&type=template&id=8cc17472&"
import script from "./CreateLesson.vue?vue&type=script&lang=js&"
export * from "./CreateLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports